export default "__VITE_ASSET__szG4eFwj__"